export * as Status from 'containers/desktop/KnowledgeBases/types/Status';

export enum Type {
	RUNNING = 'RUNNING',
	UNSTART = 'UNSTART',
	DONE = 'DONE',
	FAIL = 'FAIL',
}

export function getStatusColor(status: Type) {
	switch (status) {
		case Type.RUNNING:
			return '#2d5776';
		case Type.UNSTART:
			return 'gray';
		case Type.DONE:
			return 'green';
		case Type.FAIL:
			return '#dc3545';
	}
}

export function getStatusText(status: Type) {
	switch (status) {
		case Type.RUNNING:
			return 'Running';
		case Type.UNSTART:
			return 'Unstarted';
		case Type.DONE:
			return 'Done';
		case Type.FAIL:
			return 'Failed';
	}
}
